import { ISimpleSelectItem } from '../../components/select/SimpleSelect';
import { IncomingDocumentStatus } from 'src/types/enums';

export const INCOMING_DOCUMENT_APPROVAL_MODE_OPTIONS: ISimpleSelectItem[] = [
  {
    key: 'automatic',
    name: 'Automatisch',
  },
  {
    key: 'manual',
    name: 'Handmatig',
  },
];

export const INCOMING_DOCUMENT_STATUS_OPTIONS: ISimpleSelectItem[] = [
  {
    key: IncomingDocumentStatus.New,
    name: 'Nieuw',
  },
  {
    key: IncomingDocumentStatus.Pending,
    name: 'In Behandeling',
  },
  {
    key: IncomingDocumentStatus.Approved,
    name: 'Goedgekeurd',
  },
  {
    key: IncomingDocumentStatus.Rejected,
    name: 'Afgekeurd',
  },
];
